module.exports = __webpack_public_path__ + "static/img/smartProduct31.59c26191.png";